import { Modal, Button, Group, Text } from '@mantine/core';

interface UnsavedChangesModalProps {
  opened: boolean;
  onStay: () => void;
  onDiscard: () => void;
}

export function UnsavedChangesModal({ opened, onStay, onDiscard }: UnsavedChangesModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onStay}
      title="Unsaved Changes"
      centered
      size="sm"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
    >
      <Text size="sm" c="dimmed" mb="lg">
        You have items in progress that haven't been saved. If you leave now,
        those changes will be lost.
      </Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onStay}>
          Stay on Page
        </Button>
        <Button color="red" onClick={onDiscard}>
          Discard Changes
        </Button>
      </Group>
    </Modal>
  );
}
